import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, Col, Container, Row} from 'react-bootstrap'
import { useLocation } from 'react-router-dom';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger, Flip } from "gsap/all";
import { bloggerPageDetails } from '../types/bloggerServices';
import { getAboutPage } from '../services/blogger';
import LandingHero from '../UI/Hero/LandingHero';



gsap.registerPlugin(ScrollTrigger, Flip, useGSAP);


export default function MagazinePageTemplate() {

    const [page, setPage] = useState<bloggerPageDetails>();
    const [loaded, setLoaded] = useState<boolean>();
    const getData = async () => {
        setLoaded(false);
        try{
          const response = await getAboutPage();
          console.log(response)
          setPage(response)
        }
        catch(e){
          console.log(e);
        }
        finally{
            setLoaded(true)
        }
      }
    
      useEffect(() => {
        getData()
      }, []);

  return (
    <Container className='route-container'>
        <LandingHero issue_num='01' issue_cover='https://fatteh-media-files.s3.amazonaws.com/pages/magazine/cover1.webp'/>
        <Row>
            {/** load the cover page from blogger
             *  page?.content ? <div dangerouslySetInnerHTML={{ __html: page.content }} />: <h1>Loading ... </h1> */}
        
        </Row>
    </Container>
  );
}
